import {DisplayTag} from '@volkswagen-onehub/components-core'
import {Electricity, Gas, Hybrid, Petrol} from '@volkswagen-onehub/icons-core'
import React from 'react'
import styled from 'styled-components'
import {
    FuelIconProps,
    FullHybrid,
    MildHybrid,
} from '../../../common/components/icons/FuelIcons'
import FUELS_KEYS, {FuelCode} from '../../../utils/filters/FuelsKeys'

type FuelIcon = React.ComponentType<FuelIconProps>

// Declared in the design order: tags follow it whatever the API order
const FUEL_ICONS: Record<FuelCode, FuelIcon> = {
    PHY: Hybrid,
    FH: FullHybrid,
    MHY: MildHybrid,
    G: Petrol,
    // the design uses the same fuel drop for petrol and diesel
    D: Petrol,
    EL: Electricity,
    M: Gas,
}

const FuelTagsList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: ${(props) => props.theme.size.static150};
    margin: 0;
    padding: 0;
    list-style: none;
`

interface FuelTagsProps {
    fuels: string[]
    className?: string
}

export default function FuelTags(
    props: FuelTagsProps
): React.JSX.Element | null {
    const fuelIcons = (
        Object.entries(FUEL_ICONS) as [FuelCode, FuelIcon][]
    ).filter(([code]) => props.fuels.includes(code))

    if (!fuelIcons.length) {
        return null
    }

    return (
        <FuelTagsList className={props.className}>
            {fuelIcons.map(([code, Icon]) => (
                <li key={code}>
                    <DisplayTag
                        appearance="technical"
                        icon={<Icon variant="small" aria-hidden={true} />}
                        // eslint-disable-next-line security/detect-object-injection
                        text={FUELS_KEYS[code]}
                    />
                </li>
            ))}
        </FuelTagsList>
    )
}
